/**
 * Resolves the mimetype of a recorded-audio attachment from the URL that
 * storage-management-service returned for it (INT-1011).
 *
 * The service transcodes recordings to `.ogg` or, for WHATSAPP_API behind
 * its WAPI_AUDIO_AAC_ENABLED flag, `.aac`. Extensions arrive lowercase from
 * the Go service today; the comparison is case-insensitive anyway so a
 * future casing change cannot silently mislabel the attachment.
 */
export const getRecordedAudioMimetype = (audioUrl: string): string =>
  audioUrl.toLowerCase().endsWith('.aac') ? 'audio/aac' : 'audio/ogg';
